import React from 'react';
import PropTypes from 'prop-types';

import NavigationIcon from '../Icon/NavigationIcon.tsx';

import styles from './NavigationTab.less';
import navigationStyles from '../Navigation.less';
import Tab from '../Menu/TabConfig.js';
import useHasMounted from "../../../hooks/useHasMounted";
import { TAB } from "../Menu/menuConfig";

const NavigationTab = ({ tab, active, onClick, collapsed, dataIdentifier, tooltip, isSidebarDesktopExpanded }) => {

  const hasMounted = useHasMounted();
  if (!hasMounted) {
    active = (tab.displayName === TAB.home.displayName)
  }

  return (
    <li className={`grid-item ${styles.tabListItem}`} data-identifier={dataIdentifier}>
      <div className={`grid grid-flex grid-align-center ${styles.tab} ${active ? styles.gray_one_thousand : ''}`}>
        <button id={tab.id} type="button" onClick={onClick} className={`one-whole ${styles.tabButton} ${active  ? styles.active : ''} ${collapsed ? 'button-icon-standalone' : 'button'}`}>
          <div className={'grid grid-flex grid-fill-rows'}>
            <div className={`grid-item desk-one-fourth lap-one-fourth palm-one-twelfth align-center grid-item-fixed-width ${navigationStyles.icon}`}>
              <NavigationIcon Icon={tab.icon} color={active ? '#333333' : '#757575'} />
            </div>

            <div
              className={`grid-item one-half ${
                active ? styles.gray_one_thousand : 'font-lightgray'
              } ${collapsed ? styles.spanDisplayNone : ''}  `}
              title={tab.displayName}
              data-qa="name-cell"
            >
              {tab.displayName}
            </div>
            {isSidebarDesktopExpanded && tooltip && (
              tooltip
            )}
          </div>
        </button>
      </div>
    </li>
  );
}

NavigationTab.defaultProps = {
  active: false,
  tooltip: '',
  isSidebarDesktopExpanded: true,
};

NavigationTab.propTypes = {
  active: PropTypes.bool,
  tab: PropTypes.instanceOf(Tab).isRequired,
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.any,
  isSidebarDesktopExpanded: PropTypes.bool,
};

export default NavigationTab;
